<template>
  <div class="no-products-found py-24 flex flex-row justify-center text-white text-xl montserrat"> Pas de produit disponible </div>
</template>

<script>
    export default {}
</script>